import type { FC } from "react";

import clsx from "clsx";

import type { IUserCommunicationTemplate } from "@/src/common/UserCommunicationTemplate";
import UserCommunicationTemplate from "@/src/common/UserCommunicationTemplate";
import type { IModal } from "@Components/Modal";
import { Modal } from "@Components/Modal";

import * as css from "./UserCommunicationTemplateModal.module.css";

export interface IUserCommunicationTemplateModal {
    commBase: IUserCommunicationTemplate;
    modal?: Omit<IModal, "isOpen">;
}

const UserCommunicationTemplateModal: FC<IUserCommunicationTemplateModal> = (props) => (
    <Modal
        {...props.modal}
        className={clsx(css.userCommunicationTemplateModalComponent, props.modal.className)}
        isOpen
    >
        <UserCommunicationTemplate {...props.commBase} />
    </Modal>
);

export default UserCommunicationTemplateModal;
